<div class="dialog-header">
  <div class="header-title">
    <span class="header-span">System Notification</span>
  </div>

  <div class="buttons-block">
    <button class="header-button send-button" mat-button (click)="saveCond()" [disabled]="saveLoading"
            [ngClass]="{'disabled-button': saveLoading}">
      <span *ngIf="!saveLoading">Save</span>
      <lib-mini-progress-spinner *ngIf="saveLoading"></lib-mini-progress-spinner>
    </button>
  </div>

  <button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="middle-content">
  <div class="inputs-block">
    <div class="input-block">
      <div class="input-label">Title:</div>

      <div class="email-input-text">
        <input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation [ngModelOptions]="{standalone: true}"
               [disabled]="saveLoading" [(ngModel)]="tempCondition.title">
      </div>
    </div>

    <div class="input-block text-block">
      <div class="input-label">Subscription:</div>

      <div class="nfs-subs">
        <div class="nfs-sub existing-sub" *ngFor="let nfsSub of nfsSubs" (click)="editSub(nfsSub)">
          {{nfsSub.type}}{{nfsSub.roleName ? ': ' + nfsSub.roleName : ''}}{{nfsSub.user ? ': ' + nfsSub.user.name : ''}}
        </div>
        <div class="nfs-sub new-sub" (click)="addNewSub()">

          <mat-icon class="sub-icon">add</mat-icon>
        </div>
      </div>

    </div>

    <div class="input-block text-block">
      <div class="input-label">Notification:</div>

      <div class="email-input-text">
				<textarea #emailChangerArea matInput [required]="true" [(ngModel)]="tempCondition.msg" name="message"
                  [disabled]="saveLoading" [ngClass]="{'can-be-edited': saveLoading}"></textarea>
      </div>

    </div>
  </div>
  <div class="hints-block">
    <div class="variables-label">Temporaray Variables (clickable)</div>
    <div class="variable-blocks">

      <div class="loading-block" *ngIf="variablesLoading">
        <lib-mini-progress-spinner></lib-mini-progress-spinner>
      </div>

      <ng-container *ngIf="!variablesLoading">
        <div class="variables-block">
          <div class="variable-titles">
            <div class="variable-title" *ngFor="let tempVariable of tempVariables" matRipple
                 (click)="variableClick(tempVariable.name)">
              {{tempVariable.name}}
            </div>
          </div>
          <div class="variable-infos">
            <div class="variable-text" *ngFor="let tempVariable of tempVariables"> - {{tempVariable.description}}</div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
